import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/state-banquet',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'publications' */ './component')],
			render: ([StateBanquet]) => <StateBanquet />,
			onEnter: async ({ next }) => {
				console.log('on Enter state banquet');
				await next();
				console.log('on Enter state banquet / end');
			},
		},
	],
};

export default routes;
